import { ApiService } from '@/api/ApiService';
import { UserPhotoResponseModel } from '@/pages/AvatarPicker/types/UserPhotoResponseModel';
import { Result, ResultOf } from '@/types/result';
import { UserInfoModel } from '@/types/UserInfoModel';
import { DetermineTimeZoneResponseModel } from '@/types/Api/Response/DetermineTimeZoneResponseModel';

export interface CompleteUploadUserPhotoRequestModel {
  userId: number;
  uuid: string;
  parts: Array<{ partNumber: number; eTag: string }>;
}

export interface InitUploadUserPhotoRequestModel {
    name: string;
    contentType: string;
    fileSize: number;
}

export class UsersApi extends ApiService {
    base = 'Users';

    /**
     * Завершение загрузки фото пользователя
     */
    async completeUploadPhoto(model: CompleteUploadUserPhotoRequestModel): Promise<Result> {
        return await this.post(this.getUrl('CompleteUploadPhoto'), model);
    }

    async getCurrentInfo(): Promise<ResultOf<UserInfoModel>> {
        return await this.get(this.getUrl('GetCurrentInfo'));
    }

    async initUploadPhoto(model: InitUploadUserPhotoRequestModel): Promise<ResultOf<{value: string}>> {
        return await this.post(this.getUrl('InitUploadPhoto'), model);
    }

    async getUserPhoto(userId: string): Promise<ResultOf<UserPhotoResponseModel>> {
        return await this.get(this.getUrl('GetUserPhoto'), { userId });
    }

    async removeUserPhoto(userId: number): Promise<Result> {
        return await this.post(this.getUrl('RemovePhoto'), { userId }, true);
    }

    async getIsCurrentStudent(): Promise<Result> {
        return await this.get(this.getUrl('GetIsCurrentStudent'));
    }

    async getIsSuperAdministrator(): Promise<ResultOf<boolean>> {
        return await this.get(this.getUrl('IsSuperAdministrator'));
    }

    async disableModalRegistrationWindow(): Promise<ResultOf<boolean>> {
        return await this.post(this.getUrl('DisableModalRegistrationWindow'),{}, false);
    }

    async determineTimeZone(IANAZoneId : string) : Promise<ResultOf<DetermineTimeZoneResponseModel>>{
        return await this.get(this.getUrl('DetermineTimeZone'), { IANAZoneId });
    }

    async getIsNewFeatureModalShouldBeShown(featureName: string): Promise<Result> {
        return await this.get(this.getUrl('GetIsNewFeatureModalShouldBeShown'), { featureName });
    }

    async getUserInfo(id: number): Promise<ResultOf<UserInfoModel>> {
        return await this.get(this.getUrl('GetUserInfo'), { id });
    }

    async editUser(model: {
        id: number;
        firstName: string;
        lastName: string;
        middleName?: string;
        email: string;
        about?: string;
        phone?: string;
        timeZoneId: string;
        currencyType?: number;
    }): Promise<Result> {
        return await this.post(this.getUrl('EditUser'), model);
    }

    async addRoleSuperAdministrator(userId: number): Promise<Result> {
        return await this.post(this.getUrl('AddRoleSuperAdministrator'), { userId }, true);
    }

    async removeRoleSuperAdministrator(userId: number): Promise<Result> {
        return await this.post(this.getUrl('RemoveRoleSuperAdministrator'), { userId }, true);
    }

    async addRoleDemo(userId: number): Promise<Result> {
        return await this.post(this.getUrl('AddRoleDemo'), { userId }, true);
    }

    async removeRoleDemo(userId: number): Promise<Result> {
        return await this.post(this.getUrl('RemoveRoleDemo'), { userId }, true);
    }

    async isCurrentSuperAdministrator(): Promise<ResultOf<boolean>> {
        return await this.get(this.getUrl('IsCurrentSuperAdministrator'));
    }
    
    async getPaidFeaturesModalDaysLeft(): Promise<ResultOf<number>> {
        return await this.get(this.getUrl('GetPaidFeaturesModalDaysLeft'));
    }
}
